import Icon from 'components/Icon';
import {IconType} from 'components/Icon/types';
import {FC, ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

type CardButtonProps = {
    children: ReactNode;
    href: string;
    iconLeft: IconType;
    iconRight: IconType;
};
const CardButton: FC<CardButtonProps> = ({
    children,
    href,
    iconLeft,
    iconRight,
}) => (
    <a
        className={twMerge(
            'bg-grey-10 hover:bg-grey-900/10 active:bg-green-100',
            'border border-grey-400 active:border-green-700 rounded',
            'text-green-800 hover:no-underline',
            'py-4 px-3',
            'flex gap-4 items-center justify-center',
        )}
        href={href}
    >
        {iconLeft && <Icon icon={iconLeft} />}
        <span className="flex-1 text-nowrap text-left">{children}</span>
        {iconRight && <Icon icon={iconRight} />}
    </a>
);
export default CardButton;
